import request from '@/utils/request'

let Sensitive_wordApi = {

  /*敏感词列表*/
  list(data) {
    return request._post('/shop/plus.sensitive_word.Index/index', data);
},
/*添加敏感词*/
add(data) {
    return request._post('/shop/plus.sensitive_word.Index/add', data);
},
/*修改敏感词*/
edit(data) {
    return request._post('/shop/plus.sensitive_word.Index/edit', data);
},
/*删除敏感词*/
del(data) {
    return request._post('/shop/plus.sensitive_word.Index/del', data);
},
/*敏感词详情*/
detail(data) {
  return request._post('/shop/plus.sensitive_word.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.sensitive_word.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.sensitive_word.Setting/getSetting', data, errorback);
    },
}
export default Sensitive_wordApi;



// WEBPACK FOOTER //
// ./src/api/sensitive_word.js